import type { Degree as TDegree, User } from 'api/data.types'
import {
  kidsDegreeMap,
  fundamental1DegreeMap,
  fundamental2DegreeMap,
  mediumDegreeMap,
  teacherDegreeMap,
  kids2DegreeMap,
  childEducationDegreeMap
} from 'utils/degrees'

export const getDegree = (user: User): TDegree => {
  return user?.reader?.entity?.degree
}

export const isInfant = (user: User): boolean => {
  return childEducationDegreeMap.includes(getDegree(user))
}

export const isKids = (user: User): boolean => {
  return kidsDegreeMap.includes(getDegree(user))
}

export const isKids2 = (user: User): boolean => {
  return kids2DegreeMap.includes(getDegree(user))
}

export const isFundamental1 = (user: User): boolean => {
  return fundamental1DegreeMap.includes(getDegree(user))
}

export const isFundamental2 = (user: User): boolean => {
  return fundamental2DegreeMap.includes(getDegree(user))
}

export const isEnsinoMedio = (user: User): boolean => {
  return mediumDegreeMap.includes(getDegree(user))
}

export const isTeacher = (user: User): boolean => {
  return teacherDegreeMap.includes(getDegree(user))
}

export const isCorporate = (user: User): boolean => {
  return teacherDegreeMap.includes(getDegree(user))
}

const Degree = {
  isInfant,
  isKids,
  isKids2,
  isFundamental1,
  isFundamental2,
  isEnsinoMedio,
  isTeacher,
  isCorporate,
  getDegree
}

export default Degree
